<template>
    <main>
        <crumbs :crumbs="crumbs"></crumbs>
        <div class="wrap">
            <div class="count">
                <div class="left num" v-if="user_info.id">您目前已累计：<i>{{user_info.score}}</i>积分</div>
                <div class="left num" v-else="!user_info.id">登录后查看您的积分</div>
                <div class="right link">
                    <div class="left item" @click="toHash('good')">兑换好礼</div>
                    <div class="left item" @click="toHash('description')">积分说明</div>
                    <div class="left item" @click="toggleScoreDetail">积分明细</div>
                </div>
            </div>
            <div class="rule" id="rule">
                <div class="title">积分累计规则</div>
                <div class="line"></div>
                <div class="list">
                    <div class="item" v-for="item in rule">
                        <div class="icon"><div class="middle">{{item.title}}</div></div>
                        <div class="num-box">
                            <div class="cen">
                                <div class="num">+{{item.number}}</div>
                                <div class="text">积分</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="good" id="good">
                <div class="title">兑换好礼</div>
                <div class="line"></div>
                <div class="list">
                    <div class="left item" v-for="(item,index) in good_list">
                        <div class="image" :style="{backgroundImage:'url('+util.autoImage(item.image)+')'}"></div>
                        <div class="info">
                            <div class="tit">{{item.title}}</div>
                            <div class="score">
                                <div class="num">{{item.integral}}</div>
                                <div class="tt">积分</div>
                            </div>
                        </div>
                        <div class="hover">
                            <div class="image" :style="{backgroundImage:'url('+util.autoImage(item.image)+')'}"></div>
                            <div class="info">
                                <div class="tit">{{item.title}}</div>
                                <div class="score">
                                    <div class="num">{{item.integral}}</div>
                                    <div class="tt">积分</div>
                                </div>
                                <div class="btn">
                                    <div class="text">
                                        <div class="tt">礼品兑换</div>
                                        <div class="num">(剩余 {{item.number}}/{{item.count}})</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="description" id="description">
                <div class="title">积分规则</div>
                <div class="line"></div>
                <div class="list">
                    <div class="item">
                        <div class="tit">1、积分获取</div>
                        <div class="answer">
                            <p>用户首次注册成功，将获取500积分</p>
							<p>用户每观看直播30分钟，将获取500积分</p>
							<p>用户在直播中，参与直播互动回答，将获取500积分</p>
							<p>用户在直播中，进行留言互动，将获取500积分</p>
							<p>用户首次参观每个合作伙伴区域满10分钟，将获取500积分</p>
							<p>用户首次完成调查问卷，将获取500积分</p>
                        </div>
                    </div>
					<div class="item">
						<div class="tit">2、积分使用</div>
						<div class="answer">
							<p>积分专属2020戴尔科技峰会,仅限峰会期间使用</p>
							<p>积分可以累积，3个月内有效</p>
							<p>您可在互动专区 - 积分商城 - 积分兑好礼板块进行积分兑换</p>
						</div>
					</div>
					<div class="item">
						<div class="tit">3、积分有效期</div>
						<div class="answer">
							<p>积分自活动开始日起3个月内有效,逾期自动失效</p>
						</div>
					</div>
					<div class="item">
						<div class="tit">4、积分到账时间</div>
						<div class="answer">
							<p>根据累计规则完成互动30分钟内，点击右上角登录名，即可查看已获得的积分</p>
						</div>
					</div>
					<div class="item">
						<div class="tit">5、积分查询</div>
						<div class="answer">
							<p>请谨慎兑换积分，积分一经兑换，不能退还</p>
						</div>
					</div>
					<div class="item">
						<div class="tit">6、免责条款</div>
						<div class="answer">
							<p>积分不可兑现、不可转让,仅可在2020戴尔科技峰会活动期间使用</p>
							<p>活动主办方戴尔有权在未向您通知的情况下自行变更、终止全部或部分积分规则,戴尔无须为积分规则的变更或终止承担任何责任</p>
							<p>无论您的账户因何种原因被关闭,您的积分将自动丧失,戴尔无须为您的积分损失承担任何责任</p>
							<p>积分规则以2020戴尔科技峰会公布的最新版本为准,最终解释权由戴尔所有</p>
						</div>
					</div>
                </div>
                <div class="tip">戴尔始终致力于遵守所有可适用的法律、法规、政策以及道德准则。通过接受我们的邀请并出席本次活动，戴尔始终，加快5G网络、加快推进国家规划已明确的重大工程和基础设施建设</div>
            </div>
        </div>
        <score-detail v-if="show_score_detail" @toggleScoreDetail="toggleScoreDetail"></score-detail>
    </main>
</template>

<script>
    import Crumbs from "../../components/pc/Crumbs";
    import ScoreDetail from "../../components/pc/ScoreDetail";

    export default {
        name: 'score',
        data() {
            return {
                query:"",
                rule:[],
                good_list:[],
                show_score_detail:false,
                adv:[],
            }
        },
        components:{
            Crumbs,ScoreDetail
        },
        computed:{
            crumbs() {
				return {title:"积分商城",min_title:"Score Shop"}
            },
            user_info(){
                return this.$store.state.user_info
            }
        },
        methods: {
            toggleScoreDetail(){
                if(!this.user_info.id){
                    this.util.showAuth({
                        show:true
                    });
                }else{
                    this.show_score_detail = !this.show_score_detail
                }
            },
            toHash(id){
                document.getElementById(id).scrollIntoView(true);
            },
            getScoreGood(){
                this.http.request({
                    api:"score/getScoreGood",
                    success:(res)=>{
                        this.good_list = res.list;
                    }
                })
            },
            getScoreRule(){
                this.http.request({
                    api:"score/getScoreRule",
                    success:(res)=>{
                        this.rule = res.list;
                    }
                })
            },
            getAdv(){
                this.http.request({
                    api:"adv/getAdv",
                    data:{
                        position:12,
                    },
                    success:(res)=>{
                        this.adv = res.adv;
                        this.$nextTick(()=>{
                            this.util.showBottom(true);
                        })
                    }
                })
            },
            getUserInfo(){
                if(!this.util.getAccessToken()){
                    return false;
                }
                this.http.request({
                    api:'user/getUserInfo',
                    loading:true,
                    success:(res)=>{
                        this.$store.commit('setUserInfo',res.user);
                        this.util.setDellCookie();
                    }
                })
            }
        },
        mounted() {
            this.query = this.$route.query;
            this.getUserInfo();
            this.getScoreRule();
            this.getScoreGood();
            this.getAdv();
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .wrap{background: #f6f6f6;padding-top:20px;
        .count{width: 1200px;height:110px;margin: 0 auto; background: url("~@/assets/image/28.png") no-repeat center center;background-size:cover;border-radius: 5px;color:#fff;overflow: hidden;
            .num{margin-left: 40px;padding-left: 80px;background: url("~@/assets/image/29.png") no-repeat left center;background-size: 70px;line-height: 110px;font-size: 16px;
                i{font-weight: bold;margin-right: 2px;font-size:20px;}
            }
            .link{height:18px;line-height: 18px;font-size: 16px;margin-top: 46px;
                .item{padding: 0 20px;border-right: 1px solid #fff;transition: all .3s ease;cursor: pointer;}
                .item:nth-last-child(1){border-right: none;}
                .item:hover{color: #038df4;transition: all .3s ease}
            }
        }
        .rule{margin-top: 50px;
            .title{font-size: 26px;text-align: center;}
            .line{width: 150px;height:4px;margin: 5px auto 0; background: url("~@/assets/image/30.png") no-repeat center center;background-size: 100% 100%;}
            .list{overflow: hidden;width: 1200px;margin: 40px auto 0;
                .item{width: 380px;height:160px;float: left;margin-right: 30px;margin-bottom: 30px;border-radius: 5px;overflow: hidden;background: #fff;box-shadow: 0 0 10px 2px rgba(0,0,0,.1);
                    .icon{height:110px;color: #fff;
                        .middle{height:110px;width: 340px;padding: 0 20px; font-size: 22px;line-height: 38px;text-align: center;}
                    }
                    .num-box{height: 50px;line-height: 50px;text-align: center;
                        .cen{display: inline-block;
                            .num{float: left; font-size: 22px;color:#0176ce;}
                            .text{float: left;font-size: 14px;color:#929292;margin-left: 10px;}
                        }
                    }
                }
                .item:nth-child(3n){margin-right: 0;}
                .item:nth-child(2n){
                    .icon{background: url("~@/assets/image/32.png") no-repeat center center;background-size: cover;}
                }
                .item:nth-child(2n+1){
                    .icon{background: url("~@/assets/image/31.png") no-repeat center center;background-size: cover;}
                }
            }
        }
        .good{margin-top: 50px;
            .title{font-size: 26px;text-align: center;}
            .line{width: 130px;height:4px;margin: 5px auto 0; background: url("~@/assets/image/30.png") no-repeat center center;background-size: 100% 100%;}
            .list{overflow: hidden;width: 1200px;margin: 40px auto 0;padding: 30px 30px 70px;
                .item{width: 380px; float: left;margin-right: 30px;margin-bottom: 30px;border-radius: 5px;background: #fff;position: relative;cursor: pointer;
                    .image{height:200px;color: #fff;background-repeat: no-repeat;background-position: center center; background-size: contain;}
                    .info{padding:15px 30px;background: #fbfbfb;
                        .tit{font-size: 16px;}
                        .score{color: #0176ce;margin-top: 10px;height:30px;line-height: 30px;
                            .num{float: left; font-size: 22px;font-weight: bold;}
                            .tt{float: left;margin-left: 5px; font-size: 14px;}
                        }
                    }
                    .hover{position: absolute;top:0;left:0;width: 100%;z-index: 2;display:none;
                        .info{background: #0176cf;
                            .tit{color: #fff;}
                            .score{color: #fff;}
                            .btn{width: 310px;height:50px;border-radius: 5px;margin-top: 10px;line-height: 50px;text-align: center;background: #41b6e6;
                                .text{display: inline-block;color: #fff;
                                    .tt{float: left; font-size: 18px;}
                                    .num{float: left;font-size: 14px;margin-left: 10px;}
                                }
                            }
                        }
                    }
                }
                .item:nth-child(3n){margin-right: 0;}
                .item:nth-child(2n){
                    .icon{background: url("~@/assets/image/32.png") no-repeat center center;background-size: cover;}
                }
                .item:nth-child(2n+1){
                    .icon{background: url("~@/assets/image/31.png") no-repeat center center;background-size: cover;}
                }
                .item:hover{
                    .hover{box-shadow: 0 0 30px 5px rgba(0,0,0,.1);display: block;}
                }
            }
        }
        .description{background: #fff;padding-top: 50px;padding-bottom: 50px;
            .title{font-size: 26px;text-align: center;}
            .line{width: 130px;height:4px;margin: 5px auto 0; background: url("~@/assets/image/30.png") no-repeat center center;background-size: 100% 100%;}
            .list{width: 1200px;margin: 0 auto;
                .item{margin-top: 20px;
                    .tit{height:50px;line-height: 50px;padding-left: 30px;font-size: 20px;color:#0176ce;background: #f0f9fd;}
                    .answer{padding: 15px 90px;font-size: 14px;color:#565656;line-height: 24px;white-space: pre-line;}
                }
            }
            .tip{width: 1020px;margin: 0 auto;padding: 0 90px; font-size: 12px;color:#929292;line-height: 22px;display: none;}
        }
    }
</style>

